/*
Item: Value Dialog component for creating "Wertmerkmal" from Statistics.jsx
Name: ValueDialog
Format: Code/Frontend component
*/

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
// import { TabView, TabPanel } from 'primereact/tabview';
import { Steps } from 'primereact/steps';
import { Growl } from 'primereact/growl';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import valueTemplate from '../../service/data/TemplateValue.json';
import JsonHelper, { StatisticsNames } from '../../utils/statisticsUtils';

import '../../styles/valueDialog.css';
import { MultiLanguage } from '../../utils/MultiLanguage';
import { DropdownLabeled, MultiSelectLabeled } from '../DropdownLabeled';

import MessageService from '../../service/MessageService';

export default class ValueDialog extends Component {
  constructor(props) {
    super(props);
    this.messageService = new MessageService();
    const { closeDialogue } = this.props;
    this.closeDialogue = closeDialogue;
    this.multiLanguage = new MultiLanguage();
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    measureUnits: this.props.measureUnits,
    step: 0,
    masseinheit: 'Anzahl',
    auspraegung: [],
    auspraegungen: [],
    klassifikation: [],
    selectedId: [],
    selectedClassifications: [],
    selectedExpressions: [],
    selectedData: [],
    wertmerkmal1: [],
    wertmerkmale1: [],
    formula: '', // was []
    elements: {
      TIME_IDENTIFYING: [],
      TIME_CLASSIFYING: [],
      VALUE: [],
      REGION_CLASSIFYING: [],
      SUBJECT_CLASSIFYING: [],
      RULE: [],
    },
  })

  async handleStatisticChange(e) {
    this.setState(this.getInitialState());
    this.setState({
      valueStatistics: e.value,
    });
    if (e.value === null) {
      this.setState({ statistiktext: '' });
    } else {
      this.setState({ statistiktext: StatisticsNames[e.value] });
      this.getDataFromStat(e);
    }
  }

  async handleWertmerkmalChange(e) {
    this.setState({ wertmerkmal1: e.value });
  }

  async handleMeasureChange(e) {
    this.setState({
      masseinheit: e.value,
    });
  }

  async handleKlassifikationChange(e, zeile) {
    const { klassifikation } = this.state;
    this.setState({ visible: true });
    try {
      await this.loadValuesShort(e.value, zeile);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('ERROR in handleKlassifikationChange', err);
    } finally {
      this.setState({ visible: false });
      klassifikation[zeile] = e.value;
      this.setState({ klassifikation });
    }
  }

  handleAuspraegungChange(e, zeile) {
    const { auspraegung } = this.state;
    auspraegung[zeile] = e.value;
    this.setState({ auspraegung });
  }

  handleDelete(obj) {
    const {
      selectedClassifications,
      selectedExpressions,
      selectedData,
      selectedId,
    } = this.state;
    let classification = JsonHelper.deepCopy(selectedClassifications);
    let expression = JsonHelper.deepCopy(selectedExpressions);
    let data = JsonHelper.deepCopy(selectedData);
    let id = selectedId;
    const c = obj.classification;
    for (let i = 0; i < classification.length; i += 1) { // find classification
      if (c === classification[i]) { // get index i
        if (i === 0) {
          classification.shift();
          expression.shift();
          data.shift();
          id.shift();
        } else if (i === classification.length - 1) {
          classification.pop();
          expression.pop();
          data.pop();
          id.pop();
        } else {
          // remove entry from classification, expression, and data
          classification = classification.slice(0, i).concat(
            classification.slice(i + 1, classification.length),
          );
          expression = expression.slice(0, i).concat(expression.slice(i + 1, expression.length));
          data = data.slice(0, i).concat(data.slice(i + 1, data.length));
          id = id.slice(0, i).concat(id.slice(i + 1, id.length));
        }
        this.setState({
          selectedId: id,
          selectedClassifications: classification,
          selectedExpressions: expression,
          selectedData: data,
        });
        return;
      }
    }
  }

  handleAdd(classification, expression) {
    const line = { classification: '', expression: '' };
    if (expression) {
      const { selectedId, selectedClassifications, selectedExpressions } = this.state;
      let id = 0;
      id = selectedClassifications.length;
      if (selectedId[selectedClassifications.length - 1]) {
        id = selectedId[selectedClassifications.length - 1] + 1;
      }
      let tmp = [];
      for (let i = 0; i < expression.length; i += 1) {
        tmp.push(expression[i].value);
      }
      tmp = tmp.join(' ');
      let { selectedData } = this.state;
      selectedData = JsonHelper.deepCopy(selectedData);
      if (selectedId.indexOf(classification) === -1) {
        line.classification = classification;
        line.expression = tmp;
        selectedId.push(id);
        selectedClassifications.push(classification);
        selectedExpressions.push(expression);
        selectedData.push(line);
        this.setState({
          selectedId,
          selectedClassifications,
          selectedExpressions,
          selectedData,
          auspraegung: [],
          auspraegungen: [],
          klassifikation: [],
        });
      } else {
        this.handleButton('error', 'Hinweis', 'Klassifikation wurde bereits hinzugefügt.');
      }
    } else {
      this.handleButton('error', 'Hinweis', 'Es wurde keine Ausprägung gewählt.');
    }
  }

  handleButton(severity, summary, detail) {
    this.growl.show({ severity, summary, detail });
  }

  async getDataFromStat(e) {
    try {
      const selectedStat = [{ name: e.value }];
      // Abruf der Statistik ähnelt dem aus Statistics.jsx (in componentDidMount)
      const elementsData = await this.messageService.postDataStockProperties(selectedStat, 'structureElementsListFromStatistic', 'structure', this.returnLandString());
      const { entrys } = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
      for (let ii = 0; ii < entrys.length; ii += 1) {
        entrys[ii].uniqueId = '';
        entrys[ii].activeFilter = false;
        entrys[ii].id = ii;
        entrys[ii].text = `${this.multiLanguage.returnInLanguage(entrys[ii], 'de')} [${entrys[ii].name}]`;
        entrys[ii].title = `${this.multiLanguage.returnInLanguage(entrys[ii], 'de')} [${entrys[ii].name}]`;
        entrys[ii].code = entrys[ii].name;
        entrys[ii].children = [];
        entrys[ii].expanded = true;
        entrys[ii].type = entrys[ii].variableType;
        entrys[ii].inhalt = this.multiLanguage.returnInLanguage(entrys[ii], 'de');
      }
      const elementsList = entrys;
      const { elements } = this.state;
      // split axesList to vars
      for (let i = 0; i < elementsList.length; i += 1) {
        if (elementsList[i].type !== 'UNDEF') {
          if (!(elementsList[i].code.substr(0, 4) === 'SEED' && elementsList[i].type === 'VALUE')) {
            elements[elementsList[i].type].push(elementsList[i]);
          }
        }
      }
      this.setState({
        elements,
      });

      // Zuweisung der Elemente aus der jeweiligen Statistik
      const { VALUE, SUBJECT_CLASSIFYING, REGION_CLASSIFYING } = this.state;
      this.wertmerkmale = VALUE;
      this.subjectRegion = SUBJECT_CLASSIFYING;
      this.subjectRegion1 = REGION_CLASSIFYING;
    } catch (error) {
      console.log('Error in getDataFromStat', error);
    }
  }

  returnLandString = () => {
    // returnLandString() {
    const regional = sessionStorage.getItem('evaluationRegional');
    let isLandString = 'false';
    if (regional === 'Land') isLandString = 'true';
    return isLandString;
  }

  itemTemplate = (option) => {
    // itemTemplate(option) {
    if (option) {
      return (
        `${option.value} - ${option.label}`
      );
    }
    return '';
  }

  selectedItemsTemplate = (option) => {
    // selectedItemsTemplate(option) {
    if (option) {
      if (this.state.auspraegung[1][this.state.auspraegung[1].length - 1] === option) {
        return (
          <p style={{ display: 'inline' }}>
            {option.value}
          </p>
        );
      }
      return (
        <p style={{ display: 'inline' }}>
          {option.value}
          ,
        </p>
      );
    }
    return '...';
  }

  async loadValuesShort(merkmaleCode, zeile) {
    const { auspraegungen, auspraegung } = this.state;
    // const deepCopy_auspraegungen = this.state.auspraegungen;
    // const deepCopy_auspraegung = this.state.auspraegung;
    // this.setState({ auspraegung: deepCopy_auspraegung });
    // this.setState({ auspraegungen: deepCopy_auspraegungen });
    if (merkmaleCode === null) {
      auspraegungen[zeile] = '';
      auspraegung[zeile] = '';
    } else {
      const isSecondOption = false;
      const type = 'valueassociation';
      const ttype = 'VARIABLE';
      const objtype = 'ASSOCIATIONVALUETOCLASSIFYINGVARIABLE';
      const elementsData = await this.messageService.postRecordStructureDirectory(merkmaleCode,
        isSecondOption, type, ttype, objtype);
      if (elementsData[1] !== 'error') {
        // map smaller
        const tmp = elementsData.map((entry) => ({
          value: entry.name,
          label: this.multiLanguage.returnInLanguage(entry, 'de'),
        }));
        auspraegungen[zeile] = tmp;
        auspraegung[zeile] = '';
        this.setState({ auspraegungen });
      }
    }
  }

  actionTemplate(tabNumber, obj) {
    return (
      <div>
        <Button
          id="delete"
          icon="pi-md-delete-forever"
          onClick={() => this.handleDelete(obj)}
          className="p-button-danger"
          tooltip="Eintrag löschen"
          tooltipOptions={{ position: 'left' }}
        />
      </div>
    );
  }

  returnTabView() {
    const {
      wertmerkmal1, valueStatistics, statistiktext, klassifikation,
      auspraegung, auspraegungen, globalFilter, selectedData, formula, elements,
    } = this.state;
    // console.log('VALUE#', VALUE);
    const wertmerkmale1 = elements.VALUE.map((entry) => ({
      label: `${entry.name} - ${entry.inhalt}`,
      value: entry.name,
    }));
    const tmpS = elements.SUBJECT_CLASSIFYING.concat(elements.REGION_CLASSIFYING).concat(elements.TIME_CLASSIFYING);
    let subjectRegion = tmpS.map((entry) => ({
      label: `${entry.name} - ${entry.inhalt}`,
      value: entry.name,
    }));
    subjectRegion = subjectRegion.sort((a, b) => ((a.value > b.value) ? 1 : -1));
    // console.log('AUSP#', auspraegungen[1]);
    const deepCopy = JsonHelper.deepCopy(valueTemplate).basismerkmal;
    const tabView = deepCopy.map((entry) => (
      <div>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-12" />
          <div className="p-col-6 p-lg-6">
            <DropdownLabeled
              id="merkmal1"
              label="Zählfeld*"
              name="merkmal1"
              options={wertmerkmale1}
              value={wertmerkmal1}
              onChange={(e) => this.handleWertmerkmalChange(e)}
            />
          </div>
          <div className="p-col-2 p-lg-2">
            <span className="p-float-label">
              <InputText disabled id="statistik1" value={valueStatistics} />
              <label htmlFor="statistik1">Statistik</label>
            </span>
          </div>
          <div className="p-col-4 p-lg-4">
            <span className="p-float-label">
              <InputText disabled id="statistik1text" value={statistiktext} />
            </span>
          </div>
          <div className="card p-col-12 p-lg-12 p-grid">
            <div className="p-col-12 p-lg-12">
              <b>Klassifizierende Merkmale</b>
            </div>
            <div className="p-col-6 p-lg-6">
              <DropdownLabeled
                id="klassifikation1a"
                label="Klassifikation"
                name="klassifikation1a"
                options={subjectRegion}
                value={klassifikation[1]}
                onChange={(e) => this.handleKlassifikationChange(e, 1)}
                showClear
              />
            </div>
            <div className="p-col-5 p-lg-5">
              <MultiSelectLabeled
                id="auspraegung1a"
                label="Ausprägung"
                name="auspraegung1a"
                value={auspraegung[1]}
                options={auspraegungen[1]}
                onChange={(e) => this.handleAuspraegungChange(e, 1)}
                optionLabel="name"
                itemTemplate={this.itemTemplate}
                selectedItemTemplate={this.selectedItemsTemplate}
              />
            </div>
            <div className="p-col-1 p-lg-1">
              <Button
                id="add"
                icon="pi-md-plus"
                onClick={() => this.handleAdd(klassifikation[1],
                  auspraegung[1])}
                className="p-button-success"
                tooltip="Merkmal hinzufügen"
                tooltipOptions={{ position: 'left' }}
              />
            </div>
          </div>
          <div className="p-col-12 p-lg-12">
            <DataTable
              emptyMessage="Bitte fügen Sie mindestens eine Klassifikation hinzu."
              stateKey={`tablestate-tab${entry.tabName}`}
              globalFilter={globalFilter}
              ref={(el) => { this.dt = el; }}
              value={selectedData}
              scrollable
              scrollHeight="154px"
            >
              <Column
                filter={false}
                style={{ width: '6em' }}
                field="classification"
                header="Klassifikation"
              />
              <Column
                filter={false}
                style={{
                  width: '20em',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                field="expression"
                header="Ausprägungen"
              />
              <Column header="Aktionen" body={(ex) => this.actionTemplate(0 + 3, ex, '')} style={{ textAlign: 'center', width: '4em' }} />
            </DataTable>
          </div>
        </div>

        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-12">
            <br />
            <b>Logische Verknüpfung der klassifizierenden Merkmale*</b>
            <br />
            Reihenfolge der klassifizierenden Merkmale beibehalten, zwischen jedem
            Klassifikationsmerkmal logische Verknüpfung eintragen. Zur Auswahl stehen: <i>(</i>, <i>)</i>, <i>AND</i>, <i>OR</i>
            <p />
            <InputTextarea
              id="formula1"
              rows={1}
              cols={30}
              value={formula}
              onChange={(e) => this.setState({ formula: e.target.value.replace(/\n/g, '') })}
              onBlur={(e) => this.setState({ formula: e.target.value.toUpperCase() })}
              autoResize
            />
          </div>
        </div>
      </div>
    ));
    return tabView;
  }

  isForwardDisabled(step) {
    let ret = true;
    const {
      valueStatistics, merkmalName, merkmalDescription,
      wertmerkmal1, formula, selectedClassifications,
    } = this.state;
    const checkedForEmpty = formula.trim() !== '';
    // console.log('INBOUND#W', valueStatistics, merkmalName, merkmalDescription,
    //  wertmerkmal1, formula, selectedClassifications);
    // console.log('INBOUND#W0', valueStatistics && merkmalName && merkmalDescription);
    // console.log('INBOUND#W1', wertmerkmal1 && formula && selectedClassifications.length > 0 && checkedForEmpty);
    const checkStep0 = (valueStatistics && merkmalName && merkmalDescription);
    const checkStep1 = (wertmerkmal1 && formula && selectedClassifications.length > 0
      && checkedForEmpty);
    if (step === 0) {
      if (checkStep0) ret = false;
    } else if (step === 1) {
      if (checkStep1) ret = false;
    }
    return ret;
  }

  returnProperties(step) {
    const { selectedStatistics } = this.props;
    const page = [];
    const {
      merkmalName, merkmalDescription, valueStatistics,
      statistiktext, masseinheit, formula, measureUnits,
    } = this.state;
    page[0] = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-2 p-lg-12">
              <b>Angaben zum Wertmerkmal</b>
            </div>

            <div className="p-col-2 p-lg-2">
              <span className="p-float-label">
                <InputText maxLength="8" id="merkmalName2" value={merkmalName} onChange={(e) => this.setState({ merkmalName: e.target.value.toUpperCase() })} />
                <label htmlFor="merkmalName2">Name*</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-10">
              <span className="p-float-label">
                <InputText maxLength="70" id="merkmaltext" value={merkmalDescription} onChange={(e) => this.setState({ merkmalDescription: e.target.value })} />
                <label htmlFor="merkmaltext">Beschreibung*</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-2">
              <DropdownLabeled
                showClear
                id="statistik"
                label="Statistik*"
                name="statistik"
                options={selectedStatistics}
                value={valueStatistics}
                onChange={(e) => this.handleStatisticChange(e)}
              />
            </div>
            <div className="p-col-2 p-lg-10">
              <div style={{ height: '15px' }} />
              <InputText disabled id="statistiktext2" value={statistiktext} />
            </div>
            <div className="p-col-2 p-lg-12">
              <DropdownLabeled
                showClear
                id="statistik"
                label="Maßeinheit*"
                name="Maßeinheit*"
                options={measureUnits}
                value={masseinheit}
                onChange={(e) => this.handleMeasureChange(e)}
              />
              <span />
            </div>
          </div>
        </div>
      </div>
    );
    page[1] = (
      <div>
        &nbsp;
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-12">
            <div className="card">
              <div className="p-grid p-fluid">
                <b>Basis-Wertmerkmal für Berechnung</b>
                <div className="p-col-12 p-lg-12">
                  {this.returnTabView()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    page[2] = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-lg-12">
              <b>Zusammenfassung und Speichern</b>
              <p />
              Name:
              {' '}
              {merkmalName}
              {' '}
              -
              {' '}
              {merkmalDescription}
              <br />
              Statistik:
              {' '}
              {valueStatistics}
              {' '}
              -
              {' '}
              {statistiktext}
              <br />
              Maßeinheit:
              {' '}
              {masseinheit}
              <br />
              Formel:
              {' '}
              {formula}
              <br />
            </div>
          </div>
        </div>
      </div>
    );

    return (page[step]);
  }

  stepsRender(severity, summary, detail) {
    this.growl.show({ severity, summary, detail });
  }

  moveInSteps(direction) {
    let { step } = this.state;
    step += direction;
    this.setState({ step });
  }

  async toggleSave() {
    const ret = await this.messageService.postVariableValueBuildRuleinit();
    const ret2 = await this.messageService.postVariableValueBuildVariableinit();
    const ret3 = await this.messageService.getCreatehelperCreatetextobject();
    const {
      valueStatistics, masseinheit, formula, selectedClassifications,
      selectedExpressions, merkmalName, merkmalDescription, wertmerkmal1,
    } = this.state;

    const basisMerkmalName = wertmerkmal1; // Korrektur, war STUD
    // const basisMerkmalName = 'STUD';
    const retData = ret3.data;
    const merkmal = JsonHelper.deepCopy(ret2.contents['genesis.container.content.GenesisTMContent'].transfermodel);
    const shortText = JsonHelper.deepCopy(retData);
    // const name = this.state.merkmalName;
    // const description = this.state.merkmalDescription;
    shortText.langText[0].text = merkmalDescription;
    merkmal.name = merkmalName;
    merkmal.shortDescription = shortText;
    const rule = JsonHelper.deepCopy(ret);
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.targetVariable = merkmalName;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.targetVariableReference = merkmal;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.statistic = valueStatistics;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.measureUnit = masseinheit;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.formula = basisMerkmalName;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.decimals = 0;

    const ret4 = await this.messageService.getVariableValueBuildCreateBaseVariable();
    const ret5 = await this.messageService.getVariableValueBuildCreateFilterobject();
    const basisMerkmal = JsonHelper.deepCopy(ret4);
    // let filterMerkmal = JsonHelper.deepCopy(ret5.data);

    basisMerkmal.baseVariable = basisMerkmalName;
    basisMerkmal.baseVariableStatistic = valueStatistics;
    basisMerkmal.baseVariableMeasureUnit = masseinheit;
    basisMerkmal.formula = formula;

    const klassifikation = selectedClassifications;
    const auspraegung = selectedExpressions;

    let filterVariableName = '';
    let filterValueName = [];

    const deepCopyBasisMerkmal = JsonHelper.deepCopy(basisMerkmal);

    const tmp4 = [];
    for (let i = 0; i < klassifikation.length; i += 1) {
      if (klassifikation[i]) {
        // Klassifikationen
        const filterMerkmal1 = JsonHelper.deepCopy(ret5);
        filterVariableName = klassifikation[i];
        filterMerkmal1.filterVariableName = filterVariableName;
        // Merkmale
        filterValueName = auspraegung[i].map((entry) => entry.value);
        filterMerkmal1.filterValueName = filterValueName;
        // basisMerkmal
        tmp4[i] = filterMerkmal1;
        // deepCopyBasisMerkmal.filterVariables[i] = filterMerkmal;
      }
      deepCopyBasisMerkmal.filterVariables = tmp4;
    }

    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.baseVariableReferences[0] = deepCopyBasisMerkmal;

    let returnMessage = await this.messageService.postVariableValueBuildInsert(rule);
    // let returnMessage = ["","error"]
    if (!returnMessage) returnMessage = ['Unbekannter Fehler', 'error'];
    if (returnMessage[1] === 'error') {
      this.growl.show({
        life: 12000, severity: returnMessage[1], summary: 'Fehler', detail: returnMessage[0],
      });
    } else {
      this.setState({
        step: 0,
        merkmalName: '',
        merkmalDescription: '',
        valueStatistics: null,
        statistiktext: '',
        wertmerkmal1: undefined,
        auspraegung: [],
        auspraegungen: [],
        klassifikation: [],
        formula: '',
        selectedId: [],
        selectedClassifications: [],
        selectedExpressions: [],
        selectedData: [],
      });
      this.closeDialogue(true);
    }
  }

  toggleCancel() {
    this.setState({
      step: 0,
      merkmalName: '',
      merkmalDescription: '',
      valueStatistics: null,
      statistiktext: '',
      wertmerkmal1: undefined,
      auspraegung: [],
      auspraegungen: [],
      klassifikation: [],
      formula: '',
      selectedId: [],
      selectedClassifications: [],
      selectedExpressions: [],
      selectedData: [],
    });
    this.closeDialogue(false);
  }

  toggleCheck() {
    this.stepsRender('warn', 'Prüfen', 'Prüfung noch nicht implementiert');
  }

  renderFooter(step) {
    const back = <Button disabled={false} className="p-button-primary" label="Zurück" icon="pi pi-chevron-left" onClick={() => this.moveInSteps(-1)} />;
    const forward = <Button disabled={this.isForwardDisabled(step)} className="p-button-primary" label="Weiter" icon="pi pi-chevron-right" onClick={() => this.moveInSteps(1)} />;
    const save = <Button disabled={false} className="p-button-success" label="Speichern" icon="pi pi-check" onClick={() => this.toggleSave()} />;
    const check = <Button disabled={false} className="p-button-info" label="Prüfen" icon="pi pi-md-playlist-add-check" onClick={() => this.toggleCheck()} />;
    const cancel = <Button className="p-button-danger" label="Abbrechen" icon="pi pi-md-clear" onClick={() => this.toggleCancel()} />;
    const ret = [];

    if (step > 0) ret.push(back);
    if (step < 3) ret.push(forward);
    if (step === 3) ret.push(check);
    if (step === 2) ret.push(save);

    return (
      <div>
        {ret}
        {cancel}
      </div>
    );
  }

  render() {
    const interactiveItems = [
      {
        label: 'Angaben',
      },
      {
        disabled: this.isForwardDisabled(0),
        label: 'Berechnung',
      },
      {
        disabled: this.isForwardDisabled(1),
        label: 'Speichern',
      },
    ];
    const { measureUnits, visible, step } = this.state;
    // console.log('MEASURE', measureUnits);
    return (
      <div>
        <Growl ref={(el) => { this.growl = el; }} />
        <Dialog
          header="Lade Ausprägungen..."
          closable={false}
          closeOnEscape={false}
          visible={visible}
          modal
          onHide={() => this.setState({ visible: false })}
        >
          <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
        </Dialog>
        <Dialog
          {...this.props}
          footer={this.renderFooter(step)}
          style={{
            overflowY: 'scroll',
            width: '800px',
            top: '10px',
            transform: 'unset',
            left: '400px',
            height: '620px',
          }}
        >
          <Steps
            id="wertmerkmal_bilden"
            model={interactiveItems}
            activeIndex={step}
            onSelect={(e) => this.setState({ step: e.index })}
            readOnly={false}
          />
          {this.returnProperties(step)}
        </Dialog>
      </div>
    );
  }
}

ValueDialog.propTypes = {
  closeDialogue: PropTypes.func.isRequired,
  selectedStatistics: PropTypes.instanceOf(Object).isRequired,
};
